<div class="page-heading modal-content-header">
    <div class="layer-title">{{ header }}</div>
</div>

<div class="modal-content-body" [formGroup]="orgaFormGroup">
    <div class="panel-row with-top-margin d-flex align-items-center">
        <label>Icône d'organisation</label>
        <ed-input-file
            innerId="iconOrg"
            [allowedFormat]="['SVG', 'PNG', 'JPG', 'GIF']"
            (onSubmit)="onFileSelect($event)">
        </ed-input-file>
      </div>
    <div class="panel-row">
        <label for="name" class="required">Nom de l'organisation</label>
        <ed-textfield
            innerId="name"
            name="name"
            type="emnameail"
            placeholder=""
            [required]="true"
            [formControlName]="'name'"></ed-textfield>
    </div>
</div>

<div class="layer-actions">
    <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
    <ed-button (click)="valid()" [disabled]="canCreateEdit()">Ajouter l'organisation</ed-button>
</div>
